<template>
  <div class="cs-row">
    <div class="puzzle-box">
      <div class="show-txt show-left">{{ $t("movmentThree") }}</div>
      <Row class="patentialRow" v-for="(item, index) in data" :key="index">
        <Col span="4">
          <span>{{ lang == "zh" ? item.scopeType : item.enScopeType }}</span>
        </Col>
        <Col span="6" v-for="num in legendData.length" :key="num + '-bg'">
          <div
            class="potentialBox"
            :style="{ background: getBackground(index, num) }"
          >
            <div v-if="item['peopleNameList' + num].length > 0">
              <Poptip
                v-model="item1.visible"
                popper-class="popClass"
                placement="right"
                width="500px"
                v-for="(item1, index1) in item['peopleNameList' + num]"
                :key="index1"
                transfer
                :disabled="item1.moreFlag == 1"
              >
                <div
                  v-if="item1.moreFlag == 1"
                  class="other-item"
                  style="margin: 2px"
                  @click="onShowMore(item, num)"
                >
                  {{ lang == "zh" ? item1.userName : item1.userEName }}
                </div>
                <div
                  v-if="item1.moreFlag != 1"
                  class="peo-item"
                  style="margin: 2px"
                >
                  {{ item1.userName }}\{{ item1.userEName }}
                </div>
                <div class="poptipContent" slot="content">
                  <div style="display: flex; align-items: center">
                    <h2 style="color: black">{{ item1.userName }}</h2>
                    <h2 style="color: #666666; margin-left: 15px">
                      {{ item1.userEName }}
                    </h2>
                    <span
                      style="margin-left: 15px"
                      v-if="item1.beT1Successor > 0"
                      ><Tag>T1继任</Tag></span
                    >
                  </div>
                  <div style="display: flex; align-items: center">
                    <h3 style="color: black">{{ item1.position }}</h3>
                    <h3 style="color: #666666; margin-left: 15px">
                      {{ item1.positionETitle }}
                    </h3>
                    <Icon
                      type="ios-key-outline"
                      size="30"
                      v-if="item1.key_position == '1'"
                    />
                  </div>
                  <div style="display: flex; flex-wrap: wrap">
                    <Form :label-width="120" label-position="left">
                      <Row>
                        <!-- 人才标签 -->
                        <!-- <Col span="24">
                          <FormItem :label="$t('Talent Tag')"
                            >
                            <Tag
                              color="primary"
                              v-for="(el, index) in item1.abilityList"
                              :key="index"
                              >{{ el.ability }}</Tag
                            >
                          </FormItem>
                        </Col> -->
                        <Col span="24"
                          ><!-- 离职风险 -->
                          <FormItem :label="$t('Attrition_Risk')"
                            ><Tag
                              v-if="item1.exitRiskCode"
                              :color="tabColor(item1.exitRiskCode)"
                            >
                              {{ item1.exitRisk }}
                            </Tag></FormItem
                          >
                        </Col>
                        <Col span="24">
                          <FormItem :label="$t('Resignation_impact')">
                            <Tag
                              v-if="item1.exit_impact"
                              :color="tabTextColor(item1.exit_impact)"
                            >
                              {{
                                lang == "zh"
                                  ? item1.exit_impact
                                  : item1.exit_impactEName
                              }}
                            </Tag></FormItem
                          ><!-- 离职影响 -->
                        </Col>
                        <Col span="24"
                          ><!-- 人才池标 -->
                          <FormItem :label="$t('TalentPoolTag')">
                            <Tag
                              color="primary"
                              v-for="(el, index) in item1.talent_pool &&
                              item1.talent_pool.split(',')"
                              :key="index"
                              >{{ el }}</Tag
                            >
                          </FormItem>
                        </Col>

                        <Col span="24">
                          <FormItem :label="$t('Mobility')">
                            {{ item1.crossRegion }}</FormItem
                          ><!-- 能动性 -->
                        </Col>
                        <Col span="24">
                          <FormItem :label="$t('movment')">
                            <Tag
                              v-if="item1.movment"
                              :color="tabTextColor(item1.movment)"
                            >
                              {{
                                lang == "zh"
                                  ? item1.movment
                                  : item1.movmentEName
                              }}
                            </Tag> </FormItem
                          ><!-- 绩效趋势 -->
                        </Col>
                        <Col span="24">
                          <FormItem :label="$t('User_Potential')">
                            <Select
                              v-model="item1.newPotentialScore"
                              clearable
                              transfer
                              style="width: 100px"
                              :disabled="true"
                            >
                              <Option
                                v-for="item in NewPotentialScore"
                                :value="item.code"
                                :key="item.code"
                                >{{
                                  lang == "zh" ? item.ch_value : item.en_value
                                }}</Option
                              >
                            </Select>
                            <Button
                              type="primary"
                              icon="md-reorder"
                              size="small"
                              @click="onEditItem(item1, 'qn')"
                            >
                              {{ $t("User_Potential") }}
                            </Button>
                          </FormItem>
                        </Col>
                        <Col span="24">
                          <FormItem :label="$t('TalentCategory')">
                            {{
                              lang == "zh"
                                ? item1.talentCategoryName
                                : item1.talentCategoryEName
                            }}</FormItem
                          ><!-- 人才类别 -->
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </div>
              </Poptip>
            </div>
            <div v-else></div>
          </div>
        </Col>
      </Row>
      <Row class="patentialRow">
        <Col span="4"></Col>
        <Col
          span="6"
          v-for="(legend, lIndex) in legendRowData"
          :key="lIndex + '-legend-row'"
          >{{ legend.name }}</Col
        >
      </Row>
      <div class="show-txt show-right">{{ $t("User_Potential") }}</div>
    </div>
    <PotentialRange ref="PotentialRangeRef" @onSetScore="onSetScore" />
  </div>
</template>

<script>
import PotentialRange from "./PotentialRange.vue";
export default {
  components: {
    PotentialRange,
  },
  data() {
    return {
      userList: [],
      data: [],
      selsetDisabled: false,
      Score: [],
      PotentialScore: [],
      beEnd: "",
      visible: false,
      overallScoreList: [],
      allData: [],
      bg1: "#ffb400", //黄
      bg2: "#1e64aa", //蓝
      bg3: "#17b169", //浅绿
      bg4: "#007e4b", //深绿
      NewPotentialScore: [],
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
    legendRowData() {
      let arr = [
        {
          name: this.$t("potential1"), //专注发展
        },
        {
          name: this.$t("potential2"), //多元发展
        },
        {
          name: this.$t("potential3"), //快速成长
        },
      ];
      return arr;
    },
    legendData() {
      let arr = JSON.parse(JSON.stringify(this.legendRowData));
      return arr.reverse();
    },
  },
  methods: {
    onSetScore(e) {
      this.$emit("saveScore");
    },
    onEditItem(row, type) {
      row.visible = false;
      row.isPBFlag = "1";
      this.$refs.PotentialRangeRef.onEditItem(row, type);
    },
    onShowMore(item, colIndex) {
      this.$emit("onShowMore", item["scopeMap" + colIndex]);
    },
    getLegendBg(index) {
      return this["bg" + index];
    },
    getBackground(rowIndex, colIndex) {
      let bg1 = this.bg1;
      let bg2 = this.bg2;
      let bg3 = this.bg3;
      let bg4 = this.bg4;
      let bgColor = "";
      if (rowIndex == 2) {
        bgColor = bg1;
      }
      if (rowIndex == 1) {
        bgColor = bg3;
        if (colIndex == 1) {
          bgColor = bg2;
        }
      }
      if (rowIndex == 0) {
        bgColor = bg4;
        if (colIndex == 1) {
          bgColor = bg2;
        }
        if (colIndex == 2) {
          bgColor = bg3;
        }
      }

      return bgColor;
    },

    tabColor(val) {
      if (val == "H") return "#C66B5F";
      else if (val == "L") return "#5AA066";
      else if (val == "M") return "#CD9153";
    },
    tabTextColor(val) {
      if (val == "高") return "#C66B5F";
      else if (val == "低") return "#5AA066";
      else if (val == "中") return "#CD9153";
    },
  },
};
</script>

<style lang="less" scoped>
.peo-item,
.other-item {
  height: 24px;
  padding: 3px 7px;
  font-size: 14px;
  border-radius: 3px;
}
.other-item {
  background: #2db7f5;
}
.peo-item {
  background: #0070c0;
}
.cs-row {
  display: flex;
}
.puzzle-box {
  width: 70%;
  padding-top: 40px;
  margin: auto;
  position: relative;
}
.legend-box {
  width: 10%;
  text-align: right;
  position: relative;
}
.show-txt {
  font-weight: bold;
  font-size: 20px;
  position: absolute;
}
.show-left {
  left: 5%;
  top: 10px;
  color: #375623;
}
.show-right {
  right: 30px;
  bottom: 0px;
  color: #375623;
}
.legend-row {
  display: flex;
  align-items: center;
}
.legend-title {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 20px;
}
.legend-item {
  width: 30px;
  height: 28px;
  border: 1px solid #ededed;
  margin-right: 10px;
  margin-bottom: 10px;
}

.patentialRow {
  margin-top: 8px;
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  span {
    display: block;
    text-align: right;
    margin-right: 20px;
  }
}
.legend-title {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 20px;
}
.potentialBox {
  width: 96%;
  height: 120px;
  border: 1px solid #cccccc;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  font-size: 22px;
  color: #fff;
  box-sizing: border-box;
  overflow-y: auto;
  padding: 5px;
  text-align: left;
}
// .potentialBox:hover {
//   opacity: 0.5;
// }

.poptipContent {
  display: flex;
  flex-direction: column;
  text-align: left;
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: #4ea397;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
  border-radius: 10px;
  background: #ededed;
}
/deep/.ivu-form-item {
  margin-bottom: 5px !important;
}
</style>
<style >
.popClass {
  width: 500px;
}
</style>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/AchAssessComponentCellByPeoBoard.vue